import { IOtherFormulas } from 'components/formula-entry/modals/types';

export const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT';
export const CREATE_NEW_DEAL = 'CREATE_NEW_DEAL';
export const DUPLICATE_DEAL = 'DUPLICATE_DEAL';
export const EDIT_DEAL_START = 'EDIT_DEAL_START';
export const EDIT_DEAL_CANCEL = 'EDIT_DEAL_CANCEL';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS';
export const TRIM_DEAL_FIELDS = 'TRIM_DEAL_FIELDS';
export const UPDATE_DEAL_FIELD = 'UPDATE_DEAL_FIELD';
export const UPDATE_DEAL_DIRTY_STATUS = 'UPDATE_DEAL_DIRTY_STATUS';
export const UPDATE_PRODUCT_FIELD = 'UPDATE_PRODUCT_FIELD';
export const UPDATE_NESTED_PRODUCT_FIELD = 'UPDATE_NESTED_PRODUCT_FIELD';

export type TFieldValue = string | string[] | number | IOtherFormulas[];
